
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ImgPreview extends Vue {
  readonly viewerOptions = {
    navbar: false,
    toolbar: true,
    title: false,
    minZoomRatio: 0.01,
    maxZoomRatio: 100,
    container: document.documentElement
  }

  imgUrl = ''

  show (imgUrl: string) {
    this.imgUrl = imgUrl
    const viewer = (this.$el as any).$viewer
    viewer.show()
  }
}
